import type {DetailedHTMLProps, InputHTMLAttributes} from 'react'
import clsx from 'clsx'

type InputProps = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>

export interface CheckboxInputProps extends InputProps {
  label?: string
  fullWidth?: boolean
  noMargin?: boolean
  labelTextClass?: string
}

export const CheckboxInput = ({
  label,
  fullWidth,
  className,
  id,
  noMargin,
  labelTextClass,
  ...inputProps
}: CheckboxInputProps) => {
  return (
    <div
      className={clsx(
        `form-check form-switch form-check-solid `,
        {'mb-5': !noMargin, 'form-check-inline': !noMargin, 'w-100': fullWidth},
        className
      )}
    >
      <input id={id} className='form-check-input' type='checkbox' {...inputProps} />
      {label && (
        <label
          htmlFor={id}
          className={clsx('form-check-label', labelTextClass ? labelTextClass : 'text-muted')}
        >
          {label}
        </label>
      )}
    </div>
  )
}
